var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 69,
    viewBox: "0 0 76 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 48.5V46.5H1V68H7V67M7 48.5H14.5C16.6667 46.6667 21.9 43 25.5 43C33 43 34 46.5 38.5 46.5C42.1 46.5 46.6667 46.5 48.5 46.5C50.6433 46.5 53 48 52.5 51C52.0589 53.6468 48.3333 55 47 55.5M7 48.5V67M47 55.5H35M47 55.5C49.5 54.3333 56.7488 50.1256 67 45C74 41.5 76.5 50.5 72 53L54.5 63C51.6667 64.6667 43 67.6 31 66C19 64.4 10 66 7 67M43.5 39L23 17L32 7H54.5L63 17L43.688 38.7879M43.5 39L36.5 17M43.5 39L43.688 38.7879M28 17H36.5M58.5 17H49.5M33 11L36.5 17M36.5 17L41 11M36.5 17H49.5M45.5 11L49.5 17M49.5 17L53 11M49.5 17L43.688 38.7879M61 0V6M65 7.5L68.5 4M65.5 11H71.5M26 0V6.5M17.5 3.5L22 7.5M14.5 11.5H20.5",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.6ac7efcd49d12581255dd8d51872aebf.svg";
export { ForwardRef as ReactComponent };